import { useLoaderData } from "@tanstack/react-router";
import { RootRoute } from "@/components/Routing/RootContent";

export const RootRouteWithBranding = () => {
  const loaderData = useLoaderData({ from: "__root__" });

  return <RootRoute brandingStylesheet={loaderData?.stylesheet} />;
};
